import { Alert, Button, Card, Col, Flex, Pagination, Row } from "antd";
import { get2DecimalPointsWithCommas } from 'components/numberFormatDigits';
import dayjs from "dayjs";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import StatusTag from "components/elements/TagCustom/StatusTag";
import styles from "../styles/PayrollPeriod.module.css";
import PayrollModal from "features/payment/components/PayrollModal";
import { useForm } from "antd/es/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { getPayrollPeriod } from "../services/payrollPeriodApi";
import * as service from "../../payment/services/paymentApi";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import OvertimePayrollModal from "features/payment/components/OvertimePayrollModal";

const PayrollPeriodOngoing = ({
    getPayrollPeriodList = () => { },
    visible = false,
    payrollPeriodList = [],
    payrollPeriod = [],
    pagination = {},
    onPayrollClick = () => { },
    getPayrollPeriodDetails = () => { },
    permissions
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm();
    const [openModal, setOpenModal] = useState(false)
    const [openModalOt, setOpenModalOt] = useState(false)
    const [state, setState] = useState({})
    const dispatch = useDispatch()
    // useEffect(() => {
    //     if (visible) {
    //         getPayrollPeriodList()
    //     }
    // }, [visible])
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)

    const onSubmitEditPayroll = useCallback(async (record) => {
        try {
            // dispatch(setIsLoading(true))
            console.log("record", record);

            const modified = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: record?.id,
                paymentDate: record?.paymentDate
            }
            await service.updatePaymentDate(modified);
            // await getPayrollPeriod(payrollPeriodId)
            getPayrollPeriodList()
            form.setFieldValue("paymentDate", dayjs(payrollPeriod?.paymentDate))
            // onCancel()
            setOpenModal(false)
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            // dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, form, getPayrollPeriodList, payrollPeriod?.paymentDate])

    const onSubmitEditOvertime = useCallback(async (record) => {
        try {
            // dispatch(setIsLoading(true))
            console.log("record", record, state, openModalOt);

            const modified = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: record?.id,
                overtimeStartDate: dayjs(record?.overtimePaymentDate?.[0]).format("YYYY-MM-DD"),
                overtimeEndDate: dayjs(record?.overtimePaymentDate?.[1]).format("YYYY-MM-DD"),
            }
            await service.updateOvertimePaymentDate(modified);
            // await getPayrollPeriod(payrollPeriodId)
            getPayrollPeriodList()
            form.setFieldValue("overtimeStartDate", dayjs(payrollPeriod?.overtimeStartDate))
            form.setFieldValue("overtimeEndDate", dayjs(payrollPeriod?.overtimeEndDate))
            // onCancel()
            setOpenModalOt(false)
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            // dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, form, getPayrollPeriodList, payrollPeriod?.overtimeEndDate, payrollPeriod?.overtimeStartDate, state])

    const payrollPeriodChildren = useMemo(() => {
        let tempList = []
        payrollPeriodList?.forEach(o => {
            // console.log("o", o);
            tempList.push({
                monthStr: o.monthStr, monthStrEn: o.monthStrEn, ...o,
            })

        })
        return tempList
    }, [payrollPeriodList])

    const arrowLeft = () => {
        return <Button type="default" style={{ height: "36px" }}>
            <Flex gap={5} style={{
                placeItems: 'center'
            }}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8334 9.99996H4.16669M4.16669 9.99996L10 15.8333M4.16669 9.99996L10 4.16663" stroke="#667085" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span style={{ color: "#667085" }}>{t('prev')}</span>
            </Flex>
        </Button>
    }
    const arrowRight = () => {
        return <Button type="default" style={{ height: "36px" }}>
            <Flex gap={5} style={{
                placeItems: 'center'
            }}>
                <span style={{ color: "#667085" }}>{t('next')}</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.16666 9.99996H15.8333M15.8333 9.99996L9.99999 4.16663M15.8333 9.99996L9.99999 15.8333" stroke="#667085" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </Flex>
        </Button>
    }

    return (
        <>
            {permissions.ACCESS && (
                <>
                    <PayrollModal
                        payrollPeriod={state}
                        isModalOpen={openModal}
                        onCancel={() => { setOpenModal(false) }}
                        onBack={() => { setOpenModal(false) }}
                        onFinish={onSubmitEditPayroll}
                        action={"edit"}
                        form={form}
                    />
                    <OvertimePayrollModal
                        payrollPeriod={state}
                        isModalOpen={openModalOt}
                        onCancel={() => { setOpenModalOt(false) }}
                        onBack={() => { setOpenModalOt(false) }}
                        onFinish={onSubmitEditOvertime}
                        action={"edit"}
                        form={form}
                    />

                    {payrollPeriodChildren?.map?.((model) => (
                        <Card
                            style={{
                                border: "1px solid #EAECF0",
                                marginTop: "3vh",
                                marginBottom: "3vh"
                            }}
                        >

                            <Row gutter={[24, 16]}>
                                <Col span={24}>
                                    <Flex vertical>
                                        <span style={{ fontSize: "1.25vw", fontWeight: "bold", color: "#42526D" }}>{t('payment_period.label.period') + " " + dayjs(model?.dateStr, "MM").format("MMMM") + " ( " + model?.dataList?.[0]?.employment?.["name" + (i18n.language == 'en' ? "En" : "")] + " )"}</span>
                                        <span style={{ fontSize: "1.042vw", fontWeight: "bold", color: "#42526D" }}>{i18n.language === 'en' ? payrollPeriod?.monthStrEn : payrollPeriod?.monthStr}</span>
                                    </Flex>
                                </Col>
                                {model?.dataList?.map?.(payrollPeriod =>
                                    <>
                                        <Col span={8}>
                                            <Row justify={"space-between"}>
                                                <Col span={12} style={{ textAlign: "end" }}>
                                                    <StatusTag
                                                        value={payrollPeriod?.statusFlag}
                                                        text={i18n.language === 'en' ? payrollPeriod.statusFlagResp.nameEn : payrollPeriod.statusFlagResp.name} />
                                                </Col>
                                                <Col span={11}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D" }}>{payrollPeriod?.specialPeriod == "Y"
                                                        ? `${t('payment_period.label.special_period')} ${payrollPeriod.periodNo}`
                                                        : `${t('payment_period.label.periodAt')} ${payrollPeriod.periodNo}`}
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={10}>
                                            <Row justify="space-between">
                                                <Col span={11} style={{ textAlignLast: "end" }}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D" }}>{t('payment_period.label.payment_date')}</span>
                                                </Col>
                                                <Col span={11}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D", fontWeight: "bold" }}>{dayjs(payrollPeriod?.paymentDate).add(i18n.language === "en" ? 0 : 543, 'year').format("DD MMMM YYYY")}</span>
                                                    <EditIcon style={{ fontSize: "16px", padding: 0, alignSelf: "center", cursor: "pointer" }} onClick={() => {
                                                        setOpenModal(true);
                                                        //  setState(payrollPeriod);
                                                        if (payrollPeriod) {
                                                            form.setFieldsValue({
                                                                ...payrollPeriod,
                                                                paymentDate: dayjs(payrollPeriod?.paymentDate),
                                                                startPeriod: dayjs(payrollPeriod?.startPeriod),
                                                            })
                                                        }
                                                    }} />
                                                </Col>
                                            </Row>
                                            <Row justify="space-between">
                                                <Col span={11} style={{ textAlignLast: "end" }}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D" }}>{t('payment_period.label.overtime')}</span>
                                                </Col>
                                                <Col span={11}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D", fontWeight: "bold" }}>{dayjs(payrollPeriod?.overtimeStartDate ?? payrollPeriod?.startPeriod).format("DD/MM/" + (i18n.language == 'en' ? "YYYY" : "BBBB")) + " - " + dayjs(payrollPeriod?.overtimeEndDate ?? payrollPeriod?.endPeriod).format("DD/MM/" + (i18n.language == 'en' ? "YYYY" : "BBBB"))}</span>
                                                    <EditIcon style={{ fontSize: "16px", padding: 0, alignSelf: "center", cursor: "pointer" }} onClick={() => {
                                                        setOpenModalOt(true);
                                                        //  setState(payrollPeriod);
                                                        console.log("payrollPeriod", payrollPeriod);
                                                        if (payrollPeriod) {
                                                            form.setFieldsValue({
                                                                ...payrollPeriod,
                                                                paymentDate: dayjs(payrollPeriod?.paymentDate),
                                                                startPeriod: dayjs(payrollPeriod?.startPeriod),
                                                                overtimePaymentDate: [dayjs(payrollPeriod?.overtimeStartDate ?? payrollPeriod?.startPeriod), dayjs(payrollPeriod?.overtimeEndDate ?? payrollPeriod?.endPeriod)]
                                                            })
                                                        }
                                                    }} />
                                                </Col>
                                            </Row>
                                            <Row justify="space-between">
                                                <Col span={11} style={{ textAlignLast: "end" }}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D" }}>{t('payment_period.label.period_range')}</span>
                                                </Col>
                                                <Col span={11}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D", fontWeight: "bold" }}>{dayjs(payrollPeriod?.startPeriod).format("DD/MM/" + (i18n.language == 'en' ? "YYYY" : "BBBB")) + " - " + dayjs(payrollPeriod?.endPeriod).format("DD/MM/" + (i18n.language == 'en' ? "YYYY" : "BBBB"))}</span>
                                                </Col>
                                            </Row>
                                            <Row justify="space-between">
                                                <Col span={11} style={{ textAlignLast: "end" }}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D" }}>{t('payment_period.label.total_employee')}</span>
                                                </Col>
                                                <Col span={11}>
                                                    <span style={{ fontSize: "1.042vw", color: "#42526D" }}>{payrollPeriod?.employee ? payrollPeriod?.employee : '0'} {t("expense.expense-detail.person")}</span>
                                                </Col>
                                            </Row>
                                            <Row justify="space-between" align="middle" style={{ marginTop: "16px" }}>
                                                <Col span={11} style={{ textAlignLast: "end" }}>
                                                    <span style={{ fontSize: "1.042vw", fontWeight: "bold", color: "#354B6F" }}>{t('payment_period.label.net_amount')}</span>
                                                </Col>
                                                <Col span={11}>
                                                    <span style={{ fontSize: "1.25vw", fontWeight: "bold", color: "#354B6F" }}>
                                                        {
                                                            visible && payrollPeriod?.totalPaid !== null
                                                                ? `฿ ${get2DecimalPointsWithCommas(payrollPeriod?.totalPaid)}`
                                                                : `฿ ${payrollPeriod?.totalPaid ? payrollPeriod?.totalPaid : "x.xx"}`
                                                        }
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={6} style={{ alignContent: "end" }} flex={"auto"}>
                                            <Flex align="end" justify="end" gap={16}>
                                                {payrollPeriod?.statusFlag === "PAID"
                                                    ? <Button onClick={() => onPayrollClick(payrollPeriod?.id)} style={{ backgroundColor: "#A0AEC0", color: "white", border: "0px", boxShadow: "none" }} size="large">{t("payroll.label.detail")}</Button>
                                                    : <Button onClick={() => onPayrollClick(payrollPeriod?.id)} style={{ backgroundColor: "var(--button-color)", color: "white", border: "0px", boxShadow: "none" }} size="large">{t("payroll.label.payroll")}</Button>
                                                }
                                            </Flex>
                                        </Col>
                                    </>
                                )}
                            </Row>
                        </Card>

                    ))
                    }
                    <Pagination itemRender={(e, v, elements) => {
                        if (v == 'prev' || v == 'next')
                            return v == 'prev' ? arrowLeft() : arrowRight()
                        else return elements
                    }} className={styles.pagination} onChange={getPayrollPeriodList} defaultCurrent={1} total={pagination.total} />
                </>
            )}
        </>
    )
}

export default PayrollPeriodOngoing; 